import React, { useState, useEffect } from 'react';
import { Address, AddressCardProps } from '../types/Address';
import { useTranslations } from '../../localization/useTranslations';

const AddressCard: React.FC<AddressCardProps> = ({ addressData }) => {
  const translations = useTranslations();

  const [displayedAddressData, setDisplayedAddressData] = useState<Address | null>(addressData);

  useEffect(() => {
    setDisplayedAddressData(addressData);
  }, [addressData]);

  return (
    <div className="address-details">
      {displayedAddressData ? (
        <>
          <div className="address-details__item address-details__item--name">
            {displayedAddressData.first_name} {displayedAddressData.last_name}
            <span className="address-details__type">
              {translations?.subscriptionActivation?.deliveryAddressLabel || 'Delivery address'}
            </span>
          </div>
          <span className="address-details__item">
            {displayedAddressData.address} {displayedAddressData.number}
          </span>
          <span className="address-details__item">
            {displayedAddressData.zip} {displayedAddressData.city}
          </span>
          <span className="address-details__item">{displayedAddressData.country_iso}</span>
        </>
      ) : null}
    </div>
  );
};

export default AddressCard;
